const toDateAttendanceMap = (array = [], monthValue = null) => {
  const filtered = monthValue
    ? array.filter(a => parseInt(a.date.split("-")[1]) === parseInt(monthValue))
    : array;
  
  return filtered.reduce((all, attendance) => {
    const day = parseInt(attendance.date.split("-")[2].split("T")[0]);
    return { ...all, [day]: attendance };
  }, {});
};

export default toDateAttendanceMap;
